.arsTableCell {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.disabled {
  font-style: italic;
  background-color: #d3d3d329;
}
